declare namespace $ {

	type $mol_view__sub_shm_projects_goal_chat_1 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_chat['message_rows'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_paragraph__title_shm_projects_goal_chat_2 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_chat['message_role'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_link__arg_shm_projects_goal_chat_3 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_chat['reasoning_arg'] >
		,
		ReturnType< $mol_link['arg'] >
	>
	type $mol_link__sub_shm_projects_goal_chat_4 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_link['sub'] >
	>
	type $mol_link__click_shm_projects_goal_chat_5 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_chat['reasoning_select'] >
		,
		ReturnType< $mol_link['click'] >
	>
	type $mol_paragraph__title_shm_projects_goal_chat_6 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_chat['message_time'] >
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_view__sub_shm_projects_goal_chat_7 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_agent_message_text__text_shm_projects_goal_chat_8 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_chat['message_text'] >
		,
		ReturnType< $shm_agent_message_text['text'] >
	>
	type $shm_projects_image_viewer__content_shm_projects_goal_chat_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_projects_image_viewer['content'] >
	>
	type $mol_view__sub_shm_projects_goal_chat_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_chat_11 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_chat['after'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_view__sub_shm_projects_goal_chat_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_card__theme_shm_projects_goal_chat_13 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_chat['message_theme'] >
		,
		ReturnType< $mol_card['theme'] >
	>
	type $mol_card__attr_shm_projects_goal_chat_14 = $mol_type_enforce<
		({ 
			'role': ReturnType< $shm_projects_goal_chat['message_role_key'] >,
		})  & ReturnType< $mol_card['attr'] >
		,
		ReturnType< $mol_card['attr'] >
	>
	type $mol_card__sub_shm_projects_goal_chat_15 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_card['sub'] >
	>
	type $shm_projects_goal_thinking__entries_shm_projects_goal_chat_16 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_chat['thinking_entries'] >
		,
		ReturnType< $shm_projects_goal_thinking['entries'] >
	>
	type $shm_projects_goal_thinking__close_shm_projects_goal_chat_17 = $mol_type_enforce<
		ReturnType< $shm_projects_goal_chat['thinking_close'] >
		,
		ReturnType< $shm_projects_goal_thinking['close'] >
	>
	export class $shm_projects_goal_chat extends $shm_codex_app {
		after( ): readonly(any)[]
		message_rows( ): readonly(any)[]
		Process_messages( ): $mol_view
		message_theme( id: any): string
		message_role_key( id: any): string
		message_role( id: any): string
		Message_role( id: any): $mol_paragraph
		reasoning_arg( id: any): Record<string, any>
		Message_thinking_icon( id: any): $mol_icon_eye
		message_thinking_title( id: any): string
		reasoning_select( id: any, next?: any ): any
		Message_thinking( id: any): $mol_link
		message_time( id: any): string
		Message_time( id: any): $mol_paragraph
		Message_head( id: any): $mol_view
		message_text( id: any): string
		Message_text( id: any): $shm_agent_message_text
		Message_images( id: any): $shm_projects_image_viewer
		Message_text_box( id: any): $mol_view
		thinking_entries( ): readonly(any)[]
		thinking_close( next?: any ): any
		run( next?: any ): any
		iteration( ): number
		prerelease( ): boolean
		version( ): string
		workspace_id( ): string
		clarifications( ): readonly(any)[]
		After( ): $mol_view
		Process_view( ): $mol_view
		Message( id: any): $mol_card
		Thinking( ): $shm_projects_goal_thinking
		pages( ): readonly(any)[]
	}
	
}

//# sourceMappingURL=chat.view.tree.d.ts.map